module.exports = __webpack_public_path__ + "img/push_setting.b05c7c62.svg";